import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { QuickFilterItem } from '../../../components/DateFilter/QuickFilterItem';
import { DateRangePicker } from '../../../components/DatePicker/DateRangePicker';
import { Histogram } from '../../../components/Histogram/Histogram';
import { MobileDialog } from '../../../components/MobileDialog/MobileDialog';
import { MobileDialogButton } from '../../../components/MobileDialog/MobileDialogButton';
import { useMobileDialogDispatch } from '../../../components/MobileDialog/MobileDialogContext';
import { MobileDialogHeader } from '../../../components/MobileDialog/MobileDialogHeader';
import { useSearchState } from '../SearchContext';
import { MobileDateButton } from './MobileDateButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MobileDateFilter = ({
  selection: activeRange,
  dates = [],
  onChange
}) => {
  const [dateRangeOpen, setDateRangeOpen] = useState(false);
  const {
    dateQuickFilters,
    markedDates,
    oldestResultDate
  } = useSearchState();
  const [selectedRange, setSelectedRange] = useState(activeRange);
  const {
    t
  } = useTranslation();
  const dispatch = useMobileDialogDispatch();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("ul", {
      children: dateQuickFilters.map(item => /*#__PURE__*/_jsx(QuickFilterItem, {
        isSelected: item.isSelected,
        textKey: item.textKey,
        count: item.count,
        onClick: () => {
          onChange(item);
          dispatch({
            type: 'close-all'
          });
        }
      }, item.textKey))
    }), /*#__PURE__*/_jsx(MobileDateButton, {
      onClick: () => setDateRangeOpen(true)
    }), /*#__PURE__*/_jsx(HistogramContainer, {
      children: /*#__PURE__*/_jsx(Histogram, {
        dates: dates
      })
    }), /*#__PURE__*/_jsxs(MobileDialog, {
      dialogId: "date-range-filter",
      isOpen: dateRangeOpen,
      title: t('search.selectDateRange'),
      onClose: () => setDateRangeOpen(false),
      children: [/*#__PURE__*/_jsx(MobileDialogHeader, {
        closeIcon: "back",
        title: t('search.selectDateRange')
      }), /*#__PURE__*/_jsx(DateRangePicker, {
        range: activeRange,
        keepOpen: true,
        fullWidth: true,
        markedDates: markedDates,
        quickSelectText: t('search.oldestResult'),
        quickSelectDate: oldestResultDate,
        onChange: result => setSelectedRange(result)
      }), selectedRange.from && selectedRange.to && /*#__PURE__*/_jsx(MobileDialogButton, {
        text: t('search.showResults'),
        onClick: () => {
          onChange(selectedRange);
          dispatch({
            type: 'close-all'
          });
        }
      })]
    })]
  });
};
const HistogramContainer = styled.div.withConfig({
  displayName: "MobileDateFilter__HistogramContainer",
  componentId: "sc-6rlarg-0"
})(["padding:8px 24px;"]);